<template>
  <div>
    <v-card-actions class="d-flex justify-center">
      <v-btn icon @click="mostrar = !mostrar">
        <v-icon> {{ mostrar ? "mdi-chevron-up" : "mdi-chevron-down" }} </v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="mostrar">
        <v-divider></v-divider>

        <!-- <v-col cols="4" class="d-flex justify-space-around"> -->
          <v-row class="ma-0">

        <v-col cols="12" sm="6" md="6" class="d-flex justify-space-around pa-0">
          <v-btn small class="primary darken-1 ma-3" @click="modificarProyecto()">
            Ver Proyecto
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="d-flex justify-space-around pa-0">
          <v-btn small class="red darken-1 white--text ma-3" @click="mostrarDialogo = !mostrarDialogo">
            Eliminar
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12" class="d-flex justify-space-around pa-0">
          <v-btn small class="deep-orange accent-3 white--text ma-1" @click="tareasTaller()">
            Plan de Trabajo
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12" class="d-flex justify-space-around pa-0">
          
          <v-btn v-if="autorizador && infoProyecto.ESTATUS == 'P'" small class="success darken-2 ma-3" @click=" autorizarProyecto() ">
            Autorizar Proyecto
          </v-btn>
          <v-btn v-else-if=" infoProyecto.ESTATUS == 'C' " small class="white--text orange darken-3 ma-3" @click=" cambiarProgresoProyecto('D') ">
            Enviar a Almacen
          </v-btn>
          <v-btn v-else-if=" infoProyecto.ESTATUS == 'D' " small class="white--text orange darken-3 ma-3" @click=" cambiarProgresoProyecto('A') ">
            Enviar a Taller
          </v-btn>
          <v-btn v-else-if=" infoProyecto.ESTATUS == 'A' " small class="white--text orange darken-3 ma-3" @click=" TerminarProyecto() ">
            Terminar Proyecto
          </v-btn>
          <!-- <v-btn v-else-if="btnTerminarProyecto" small class="white--text orange darken-3 ma-3" @click="TerminarProyecto()">
            Terminar Proyecto
          </v-btn> -->
        </v-col>

          </v-row>
        
      </div>
    </v-expand-transition>

    <v-dialog v-model="mostrarDialogo" max-width="600px">
      <v-card>
        <v-card-title class="">
          ¿Seguro que quieres cancelar el Proyecto?
        </v-card-title>

        <v-card-subtitle class="mt-3 text--primary text-subtitle-1">
          <span class="font-weight-bold"> Folio : </span>
          {{ this.infoProyecto.FOLIO }}
        </v-card-subtitle>

        <v-divider></v-divider>
        <v-card-actions class="mx-2 d-flex justify-space-around">
          <v-btn  class="grey darken-1" dark @click="mostrarDialogo = false">
            Cancelar
          </v-btn>
          <v-btn  light class="red" dark @click="eliminarProyecto">
            Eliminar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: ["infoProyecto"],
  data() {
    return {
      mostrar: false,
      mostrarDialogo: false,
      autorizador:false,
      btnTerminarProyecto:false,
    };
  },

  computed: {
    ...mapGetters(["getURLAPI",'getRolesUsuario','getUsuario']),
  },

  methods: {
    modificarProyecto() {
      this.$router.push(`/modificarProyecto/${this.infoProyecto.PROYECTO_ID}`);
    },

    // ------------------------------------------------------------------------------
    cambiarProgresoProyecto( estatus ) {
      let close; 
      if( estatus == 'D' )
      {
          close = confirm(`¿Seguro que quieres enviar el proyecto (${this.infoProyecto.FOLIO}) al 'Almacen'?`);
      }
      else if( estatus == 'A' )
      {
        close = confirm(`¿Seguro que quieres enviar el proyecto (${this.infoProyecto.FOLIO}) al 'Taller'?`);
      }

      if (close) {
        let datos = {
          ESTATUS: estatus,
          USUARIO_MODIFICACION: this.getUsuario
        };
        axios.post(`${this.getURLAPI}/Proyecto/estatusProyecto/${this.infoProyecto.PROYECTO_ID}`,datos)
        .then(({ data }) => {
          this.$emit('snackbar',data);
          this.$emit('ActualizarProyectos');
        })
        .catch(()=>
        console.log("FALLO"));
      }
    },

    // ------------------------------------------------------------------------------
    eliminarProyecto() {
      let datos = {
        ESTATUS: "B",
        USUARIO_MODIFICACION: this.getUsuario
      };
      axios.post(`${this.getURLAPI}/Proyecto/estatusProyecto/${this.infoProyecto.PROYECTO_ID}`,datos)
      .then(({ data }) => {
        this.$emit('snackbar',data);
        this.$emit('ActualizarProyectos');
      })
      .catch(()=>
      console.log("FALLO"));
    },

    // ------------------------------------------------------------------------------
    autorizarProyecto(){
      let close = confirm(`¿Seguro que quieres autorizar el proyecto: ${this.infoProyecto.FOLIO}?`);
      if (close) {
        let datosForm = new FormData();
        datosForm.append("PROYECTO_ID", this.infoProyecto.PROYECTO_ID);
        datosForm.append("FOLIO", this.infoProyecto.FOLIO);
  
        axios.post(`${this.getURLAPI}/Proyecto/autorizarProyecto`,datosForm)
        .then(({ data }) => {
        
          let status = data.STATUS;
          this.$root.vtoast.show(
            { message: data.MSG, color: status == 'OK' ? 'success darken-2':'red darken-2', 
            timer:10000, icon: status == 'OK' ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          if (status == 'OK') this.$emit('ActualizarProyectos');
  
        })
      }
    },

    // ------------------------------------------------------------------------------
    TerminarProyecto(){
      let close = confirm(`¿Seguro que quieres terminar el proyecto: ${this.infoProyecto.FOLIO}?`);
      if (close) {
        let datosForm = new FormData();
        datosForm.append("PROYECTO_ID", this.infoProyecto.PROYECTO_ID);
        datosForm.append("FOLIO",       this.infoProyecto.FOLIO);

        axios.post(`${this.getURLAPI}/Proyecto/terminarProyecto`,datosForm)
        .then(({ data }) => {

          let status = data.STATUS;
          this.$root.vtoast.show(
            { message: data.MSG, color: status == 'OK' ? 'success darken-2':'red darken-2', 
            timer:10000, icon: status == 'OK' ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          if (status == 'OK') this.$emit('ActualizarProyectos');

        })
      }
    },

    // ------------------------------------------------------------------------------
    tareasTaller(){
      this.$router.push(`/TareasTaller/${this.infoProyecto.PROYECTO_ID}`);
    }
  },

  created(){
    if ((this.getRolesUsuario.includes("AUTO") && this.infoProyecto.ESTATUS != 'A' && this.infoProyecto.ESTATUS != 'T') || (this.getRolesUsuario.includes("SA") && this.infoProyecto.ESTATUS != 'A' && this.infoProyecto.ESTATUS != 'T')) {
      this.autorizador = true;
    }
    // else if(this.getRolesUsuario.includes("AUTO") && this.infoProyecto.ESTATUS != 'T' || this.getRolesUsuario.includes("SA") && this.infoProyecto.ESTATUS != 'T'){
    //   this.btnTerminarProyecto = true;
    // }
  }
};
</script>

<style></style>
